import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LinkService } from 'src/app/services/general/link.service';

@Component({
  selector: 'app-term',
  templateUrl: './term.page.html',
  styleUrls: ['./term.page.scss'],
})
export class TermPage implements OnInit, OnDestroy {

  private backHelpPage: boolean;

  /**
   * Constructor
   * @param router router
   * @param location location
   * @param userService user service
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      
  }

  /**
   * Watch Route
   */
  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      if (param.backHelpPage) {
        this.backHelpPage = true;
      } else if (route?.extras?.state?.backHelpPage) {
        this.backHelpPage = true;
      } else {
        this.backHelpPage = false;
      }
    });
  }

  goBack() {
    if (this.backHelpPage) {
      this.goHelpPage();
    } else {
      this.goMainPage();
    }
  }

  goHelpPage() {
    this.router.navigate(['/about/help']);
  }

  /**
   * Go main page
   */
  goMainPage() {
    this.linkService.goMainPage();
  }

  /**
   * Go about home page
   */
  goAboutHomePage() {
    this.router.navigate(['/about/home']);
  }

  /**
   * Go contact page
   */
  goContactPage() {
    this.router.navigate(['/about/contact']);
  }

}
